import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActivityTypeSelectorComponent } from './activity-type-selector/activity-type-selector.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  declarations: [ActivityTypeSelectorComponent],
  imports: [CommonModule, TranslateModule, MatButtonToggleModule, ReactiveFormsModule, MatRadioModule],
  exports: [ActivityTypeSelectorComponent],
})
export class ActivityTypeSelectorModule {}
